import styledC from 'styled-components';

import MenuItem from '../../layout/Menu/MenuItem';

export type VirtualizedMenuItemProps = {
  start: number;
  height: number;
};

const VirtualizedMenuItem = styledC(MenuItem).attrs<VirtualizedMenuItemProps>(
  (props) => ({
    'aria-disabled': props.disabled ? true : undefined,
    style: {
      transform: `translateY(${props.start}px)`,
      height: `${props.height}px`,
    },
  }),
)<VirtualizedMenuItemProps>`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`;

VirtualizedMenuItem.displayName = 'VirtualizedMenuItem';

export default VirtualizedMenuItem;
